module.exports = __webpack_public_path__ + "static/media/Maria-Tash-Multicolor-White-gold-Earring-Lyst_thumb.d7fe3b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Maria-Tash-Multicolor-White-gold-Earring-Lyst_thumb.png
// module id = 240
// module chunks = 0